import type { VenueMarketingContent } from '../dto/venue-marketing.dto.js'

/** A section of a marketing page. `sectionOrder` is ordering, not a section. */
export type VenueMarketingSectionKey = Exclude<keyof VenueMarketingContent, 'sectionOrder'>

/**
 * What each section is called where a person reads about it: the settings
 * screen's form, and the record of what a connected assistant changed.
 *
 * One list, because both name the same sections to the same people, and a page
 * edited from the screen as "Bar packages" should not come back in the record
 * of changes as `barpackages`. A `Record` over the contract's keys, so a section
 * added there fails to compile until it is named here.
 */
export const VENUE_MARKETING_SECTION_LABELS: Readonly<Record<VenueMarketingSectionKey, string>> = {
  hero: 'Hero',
  intro: 'Introduction',
  guide: 'Your planner',
  snapshot: 'Price snapshot',
  included: 'What’s included',
  pricing: 'Pricing tables',
  addons: 'Add-ons',
  spend: 'Typical spend',
  micro: 'Micro weddings',
  terms: 'Terms',
  contact: 'Contact',
  cta: 'Call to action',
  footer: 'Footer',
  brand: 'Logos',
  grapeband: 'Banner',
  premium: 'Premium packages',
  privateEvents: 'Private events',
  buyout: 'Buyout',
  community: 'Community',
  outdoor: 'Outdoor activities',
  packages: 'Wedding packages',
  barpackages: 'Bar packages',
  lodging: 'Lodging',
  overnight: 'Overnight stays',
  spaces: 'Spaces',
  alacarte: 'À la carte',
}
